<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <h4>Episodes</h4>
            <div class="text-muted">{{ total }} episodes</div>
          </CCardHeader>
          <CCardBody>
            <CInput v-model="search" placeholder="Search episodes" class="mt-2 mb-4 clear-icon">
              <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
              <template v-if="search" #append-content
                ><CButton @click="clearSearch"><CIcon name="cil-x"/></CButton
              ></template>
            </CInput>
            <EpisodesTable 
              :items="items" 
              :active-page="activePage" 
              :pages="pages" 
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import _ from 'lodash'
import EpisodesTable from './EpisodesTable'
import { mapGetters } from 'vuex'

export default {
  name: 'Episodes',
  components: { EpisodesTable },
  data() {
    return {
      search: '',
      limit: 10,
    }
  },
  watch: {
    activePage() {
      this.getData()
    },
    search: {
      handler() {
        // same if set in mounted
        if (this.search !== this.searched) {
          this.triggerSearch()
        }
      },
    },
  },
  mounted() {
    if (this.total > 0) {
      // apperently we've been here before
      this.search = this.searched
      if (this.paged > 1) {
        // works for first page: need a reload here cause of activePage
        this.$router.push({ query: { page: this.paged } })
      }
    } else {
      this.getData()
    }
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  computed: {
    activePage() {
      const { query } = this.$route
      return query && query.page ? Number(query.page) : 1
    },
    pages() {
      return Math.ceil(this.total / this.limit)
    },
    ...mapGetters({
      items: 'episodes',
      total: 'episodesTotal',
      paged: 'episodesPaged',
      searched: 'episodesSearched',
    }),
  },
  methods: {
    rowClicked(item) {
      this.$router.push({ path: `episodes/${item.id}` })
    },

    getData(triggerSearch = false) {
      this.$store.dispatch('getEpisodes', {
        $api: this.$api,
        search: this.search,
        limit: this.limit,
        page: triggerSearch ? 1 : this.activePage,
      })
    },

    triggerSearch: _.debounce(function() {
      this.getData(true)
    }, 500),

    clearSearch() {
      this.search = ''
    },
  },
}
</script>

<style>
.clear-icon .btn {
  height: 24px;
  padding: 0;
  margin: -4px;
}
.clear-icon .input-group-append > .input-group-text {
  background-color: white;
}
</style>
